export default function isEmptyId(id: any) {
  return !id || id === '00000000-0000-0000-0000-000000000000';
}
